import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

import environment from '../environment';

const socket = (() => {
    const client = (() => {
        let instance;

        class Client {
            static get stomp () {
                if (!instance) {
                    instance = Client.createConnection();
                }
                return instance;
            }

            static reconnect (headers, success, error) {
                instance = Client.createConnection();
                instance.connect(headers, success, error);
            }

            static createConnection () {
                const socketjs = new SockJS(`${location.protocol}//${environment.get('CONFIG.NOTIFICATIONS.SOCKET_HOST')}`);
                const stomp = Stomp.over(socketjs);
                stomp.heartbeat.outgoing = 20000;
                stomp.heartbeat.incoming = 0;
                return stomp;
            }
        }

        return Client;
    })();

    const subscription = (() => {
        let instance = new Map();

        class Subscription {
            static subscribe (destination, callback, headers = {}) {
                instance.set(destination, client.stomp.subscribe(destination, callback, headers));
            }

            static unsubscribe (destination) {
                if (instance.has(destination)) {
                    instance.get(destination).unsubscribe();
                    instance.delete(destination);
                }
            }

            static unsubscribeAll () {
                instance.forEach((i) => {
                    i.unsubscribe();
                });
                instance = new Map();
            }
        }

        return Subscription;
    })();

    const connect = callback => {
        let tryingReconnect;
        let tryingCount = 0;

        const headers = {
            login: environment.get('CONFIG.NOTIFICATIONS.USER'),
            passcode: environment.get('CONFIG.NOTIFICATIONS.PASS'),
            host: environment.get('CONFIG.NOTIFICATIONS.VHOST')
        };

        const _error = msg => {
            try {
                console.log(`SOCKET: Error ${msg}`);
                if (msg.indexOf('Lost connection') > 0) {
                    if (!tryingReconnect) {
                        tryingReconnect = setInterval(() => {
                            if (tryingCount > 10) {
                                console.log('Failed to reconnected...');
                                clearInterval(tryingReconnect);
                                tryingReconnect = undefined;
                                tryingCount = 0;
                            } else if (!client.stomp.connected) {
                                console.log('Trying reconnect...');
                                client.reconnect(headers, _success, _error);
                                tryingCount++;
                            } else {
                                console.log('Reconnected with success!...');
                                clearInterval(tryingReconnect);
                                tryingReconnect = undefined;
                                tryingCount = 0;
                            }
                        }, 60000);
                    }
                }
            } catch (err) {
                console.log(err);
            }
        };

        const _success = () => {
            console.log('SOCKET: Connected');
            client.stomp.connected = true;
            callback();
        };

        if (!client.stomp.connected) {
            client.stomp.connect(headers, _success, _error);
        }
    };

    const subscribe = (destination, callback, headers = {}) => {
        subscription.subscribe(destination, callback, headers);
    };

    const unsubscribe = (destination) => {
        subscription.unsubscribe(destination);
    };

    unsubscribe.all = () => {
        subscription.unsubscribeAll();
    };

    const publish = (topic, data, header = {}) => {
        client.stomp.send(topic, header, data);
    };

    return {
        connect,
        publish,
        subscribe,
        unsubscribe
    };
})();

export default socket;



// WEBPACK FOOTER //
// ./src/scripts/api/socket.js